import { FaUser, FaPhone, FaFileAlt, FaEye, FaTrash, FaEdit } from 'react-icons/fa';
import { formatarCpfCnpj, formatarTelefone } from '../utils/validators';

const ClientCard = ({ cliente, onClick, onVerDocumentos, onEditar, onExcluir }) => {
  const handleCardClick = (e) => {
    // Prevenir que cliques nos botões disparem o onClick do card
    if (e.target.closest('button')) {
      return;
    }
    onClick(cliente);
  };

  const handleVerDocumentos = (e) => {
    e.stopPropagation();
    onVerDocumentos(cliente);
  };

  const handleEditar = (e) => {
    e.stopPropagation();
    onEditar(cliente);
  };

  const handleExcluir = (e) => {
    e.stopPropagation();
    onExcluir(cliente);
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 cursor-pointer border border-gray-200 hover:border-blue-500"
    >
      <div className="flex items-center mb-4">
        <div className="bg-blue-100 p-3 rounded-full">
          <FaUser className="text-blue-600 text-2xl" />
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-gray-800 truncate">
            {cliente.nome}
          </h3>
          {cliente.cpf_cnpj && (
            <p className="text-sm text-gray-500">{formatarCpfCnpj(cliente.cpf_cnpj)}</p>
          )}
        </div>
      </div>

      <div className="space-y-2">
        {cliente.telefone && (
          <div className="flex items-center text-gray-600">
            <FaPhone className="text-gray-400 mr-2" />
            <span className="text-sm">{formatarTelefone(cliente.telefone)}</span>
          </div>
        )}

        <div className="flex items-center text-gray-600">
          <FaFileAlt className="text-gray-400 mr-2" />
          <span className="text-sm">
            {cliente.total_documentos} {cliente.total_documentos === 1 ? 'documento' : 'documentos'}
          </span>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-gray-500">
            Clique para ver detalhes
          </span>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={handleVerDocumentos}
            className="flex-1 flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition duration-200"
          >
            <FaEye />
            <span>Documentos</span>
          </button>
          <button
            onClick={handleEditar}
            className="flex items-center justify-center bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-lg text-sm font-medium transition duration-200"
            title="Editar cliente"
          >
            <FaEdit />
          </button>
          <button
            onClick={handleExcluir}
            className="flex items-center justify-center bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition duration-200"
            title="Excluir cliente"
          >
            <FaTrash />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientCard;
